export enum RoomsEnum {
  RIDE_ROOM_PRE = "-ride-room-pre",
  RIDE_ROOM = "-ride-room",
  JOIN_RIDER_TO_ROOM = "join-rider-to-room",
  JOIN_RIDER_TO_ROOM_FOR_SCHEDULED_RIDE = "join-rider-to-room-for-scheduled-ride",
  CANCEL_SCHEDULED_RIDE_CRON = "cancel-scheduled-ride-cron",
  JOIN_AVAILABLE_DRIVERS_TO_ROOM = "join-availableDrivers-to-room",
  JOIN_DRIVERS_TO_ORDERS = "join-drivers-to-orders",
  DISPUTE_ROOM = "-dispute-room",
}
